import React from 'react'
import {
  IProps as IFeatureSpotlightTestimonial,
  FeatureSpotlightTestimonial,
} from 'marketing-site/src/library/components/FeatureSpotlightTestimonial'
import { IFeatureSpotlightWithTestimonial as IContentfulFeatureSpotlightTestimonial } from 'marketing-site/@types/generated/contentful'

import { transformFeatureSpotlight } from 'marketing-site/src/transformers/components/ContentfulFeatureSpotlight'
import { transformFeatureTestimonial } from 'marketing-site/src/transformers/elements/ContentfulFeatureTestimonial'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulFeatureSpotlightTestimonial = (
  featureSpotlightTestimonial: IContentfulFeatureSpotlightTestimonial,
) => (
  <EntryMarker entry={featureSpotlightTestimonial}>
    {() => (
      <FeatureSpotlightTestimonial
        {...transformFeatureSpotlightTestimonial(featureSpotlightTestimonial)}
      />
    )}
  </EntryMarker>
)

export function transformFeatureSpotlightTestimonial(
  featureSpotlightTestimonial: IContentfulFeatureSpotlightTestimonial,
): IFeatureSpotlightTestimonial {
  return {
    ...transformFeatureSpotlight(featureSpotlightTestimonial),
    testimonial: transformFeatureTestimonial(featureSpotlightTestimonial),
    productVideo:
      featureSpotlightTestimonial.fields.video &&
      featureSpotlightTestimonial.fields.video.fields.file.url,
    productVideoWebm:
      featureSpotlightTestimonial.fields.videoWebm &&
      featureSpotlightTestimonial.fields.videoWebm.fields.file.url,
  }
}
